/**
 * Visar valt filnamn i etiketten för stylade filuppladdningsfält, som annars
 * bara visar webbläsarens egen "Ingen fil vald".
 *
 * Ersätter FrontendSrc/patternlab/js/fileupload.js.
 */
export function initFileUpload(): void {
    document.querySelectorAll<HTMLInputElement>('.js-customfileupload').forEach(input => {
        input.addEventListener('change', () => {
            // files[0].name i stället för att parsa ut basename ur value:
            // value är "C:\fakepath\namn.pdf" och originalets manuella
            // strängklippning gick sönder på filnamn som innehöll snedstreck.
            const name = input.files?.[0]?.name;
            if (!name) return;

            const label = input.previousElementSibling;
            if (label instanceof HTMLLabelElement) label.textContent = name;
        });
    });
}
